import { render, staticRenderFns } from "./AddProductAttributesVariantsStep.vue?vue&type=template&id=776d676d"
import script from "./AddProductAttributesVariantsStep.ts?vue&type=script&lang=ts&external"
export * from "./AddProductAttributesVariantsStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports